import {
  SupplierRelationshipFulfillmentType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";

export const useFulfillmentTypeEligibility = ({
  allowCollectionOnCheckout,
  connection,
  directDeliveryArea,
  sdDeliveryArea,
  eligibleForHaulierOverride = false,
  isUnbundling = false,
}: {
  allowCollectionOnCheckout: boolean;
  connection:
    | { fulfillmentType: SupplierRelationshipFulfillmentType | null }
    | undefined
    | null;
  directDeliveryArea:
    | SupplierStorefrontV2GetResponseType["DeliveryArea"]
    | undefined;
  sdDeliveryArea:
    | SupplierStorefrontV2GetResponseType["DeliveryArea"]
    | undefined;
  eligibleForHaulierOverride?: boolean;
  isUnbundling?: boolean;
}) => {
  const isAssignedCourier = connection?.fulfillmentType === "courier";
  const isAssignedHaulier = connection?.fulfillmentType === "haulier";
  const isAssignedDirect = connection?.fulfillmentType === "direct";
  const isEligibleForDistribution = !!sdDeliveryArea;

  const isEligibleForDirect =
    isAssignedDirect ||
    ((!isAssignedCourier || isUnbundling) && Boolean(directDeliveryArea));

  const isEligibleForCourier = !isAssignedHaulier;

  const isEligibleForCollection =
    allowCollectionOnCheckout || connection?.fulfillmentType === "collection";

  /**
   * Add additional logic here to handle showing haulier if pallet override enabled
   */
  const isEligibleForHaulier = isAssignedHaulier || eligibleForHaulierOverride;

  return {
    isEligibleForCollection,
    isEligibleForCourier,
    isEligibleForDirect,
    isEligibleForHaulier,
    isEligibleForDistribution,
  };
};
